import { useTableDictionaries } from '@/creditflowresearch/application/TableDictionaries';
import { DictionaryLabelCell } from '@/creditflowresearch/ui/common/components/DataCells';

import styles from '@/creditflowresearch/ui/components/bondscreener/Cells/cells.module.scss';

interface IIndustryCellProps {
  industryId: string,
  subindustryId: string,
}

const IndustryCell = ({ industryId, subindustryId }: IIndustryCellProps) => {
  const { industries, subindustries } = useTableDictionaries();

  return (
    <DictionaryLabelCell
      className={ styles.sectorLabel }
      category={ industries?.getById(industryId) }
      subcategory={ subindustries?.getById(subindustryId) }
    />
  );
};

export default IndustryCell;
